import 'core-js/features/url';
import MeshHelper from 'mesh-helper';
import Forms from 'App/Forms';
import Lightbox from 'App/Lightbox';
import JsCookieConsent from 'App/Cookiebar';
import PageHeader from 'App/PageHeader';
import AttentionBanderole from 'App/AttentionBanderole';
import ContentOverlay from 'App/ContentOverlay';
import ExternalLinkPromptPopup from 'App/ExternalLinkPromptPopup';
import ProductionBuild from 'Utils/ProductionBuild';
import GridBreak from 'Utils/GridBreak';
const objectFitImages = require('object-fit-images');

require('custom-event-polyfill');

class App {
	constructor() {
		objectFitImages(false, { watchMQ: false, skipTest: false });
		new PageHeader({
			header: '.js-page-header',
			hamburger: '.js-hamburger-menu',
			searchOverlay: '.js-search-overlay',
			searchBar: '.js-searchbar',
			searchOverlayToggle: '.js-toggle-search-overlay',
			languageMenu: '.js-language-menu',
			languageMenuToggle: '.js-toggle-language-menu',
			openNavElem: '.js-open-nav',
			closeNavElem: '.js-close-nav',
			navAccordion: '.js-navAccordion',
			logo: '.js-logo',
		});

		new Forms();
		new GridBreak();
		new Lightbox();
		new JsCookieConsent({
			options: {
				required: {
					required: true,
					session: true,
					cookies: ['PHPSESSID', 'cookieoption'],
				},
				analysis: {
					cookies: ['_ga', '_gat', '_gid', '_ga_1S0WX4XQVM'],
				},
				marketing: {
					cookies: ['usida', '_fbp'],
				},
			},
		});
		new AttentionBanderole({
			banderole: '.js-attention-banderole',
			closeButton: '.js-close-button',
			hideCookie: {
				name: 'hide_attention_banderole',
				expiresAfterDays: 1,
			},
		});

		if (!ProductionBuild.detect()) {
			new MeshHelper({
				containerClass: 'g-container',
				voidClass: 'g-void',
				columnClass: 'g-col',
			});
		}

		window.Hyphenopoly.config({
			require: {
				de: 'Silbentrennungsalgorithmus',
				fr: 'Standardisation',
				it: 'Standardizzazione',
			},
			setup: {
				selectors: {
					body: {},
				},
			},
		});
	}
}

new App();
